import { X } from 'lucide-react';
import { useTranslation } from '../../i18n';

export interface ToastProps {
  message: string;
  /** Label of the optional inline action button (e.g. "Undo"). */
  actionLabel?: string;
  onAction?: () => void;
  onDismiss: () => void;
}

/** Presentational toast. Positioning and timers live in `ToastProvider`. */
export function Toast({
  message,
  actionLabel,
  onAction,
  onDismiss,
}: ToastProps) {
  const { t } = useTranslation();
  const hasAction = Boolean(actionLabel && onAction);

  return (
    <div
      role="status"
      className="pointer-events-auto flex max-w-md items-center gap-2 rounded-pill border border-white/10 bg-hc-overlay py-1 ps-5 pe-1 text-sm text-white shadow-card-lg"
    >
      <span className="min-w-0 flex-1 py-2">{message}</span>
      {hasAction && (
        <button
          type="button"
          onClick={onAction}
          className="min-h-[44px] rounded-pill px-3 font-extrabold text-hc-accent-soft transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-hc-accent"
        >
          {actionLabel}
        </button>
      )}
      <button
        type="button"
        onClick={onDismiss}
        aria-label={t('common.close')}
        className="flex min-h-[44px] min-w-[44px] items-center justify-center rounded-full text-white/60 transition-colors hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-hc-accent"
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
